import { ReadOnlyProjectCanvas } from "@/components/project/read-only-project-canvas"
import type { ProjectByIdResult } from "@/types/zero"
import { queries } from "@oblique/shared/zero"
import { useQuery } from "@rocicorp/zero/react"
import { useParams } from "react-router"

export const PublicSharePage = () => {
	const { shareToken } = useParams<{ shareToken: string }>()
	const [project, status] = useQuery(
		queries.projects.byShareToken(shareToken ?? ""),
	)

	if (status.type === "unknown") {
		return (
			<div className="flex h-screen items-center justify-center bg-background">
				<div className="text-muted-foreground">Loading…</div>
			</div>
		)
	}

	if (status.type === "error" || !project) {
		return (
			<div className="flex h-screen flex-col items-center justify-center gap-4 bg-background">
				<h1 className="text-xl font-semibold">Project not found</h1>
				<p className="text-muted-foreground">
					This project does not exist or sharing has been disabled.
				</p>
			</div>
		)
	}

	return (
		<div className="relative h-screen w-screen overflow-hidden bg-muted">
			<ReadOnlyProjectCanvas project={project as ProjectByIdResult} />
			<div className="pointer-events-none absolute left-4 top-4 z-50 rounded-xl border bg-background/90 px-4 py-3 shadow-sm backdrop-blur">
				<h1 className="text-sm font-semibold">{project.name}</h1>
				{project.description ? (
					<p className="mt-1 max-w-sm text-xs text-muted-foreground">
						{project.description}
					</p>
				) : null}
			</div>
			<div className="pointer-events-none absolute bottom-4 left-4 z-50 text-xs text-muted-foreground">
				Shared via Oblique
			</div>
		</div>
	)
}

export default PublicSharePage
